/** Money helpers — the API speaks integer cents; the UI shows dollars. */

/** Cents → `"1234.56"` (form value). */
export function centsToDollars(cents: number | null | undefined): string {
  if (cents == null) return "";
  return (cents / 100).toFixed(2);
}

/** A dollar string (`"1,234.5"`, `"12"`, `""`) → integer cents, rounded. */
export function dollarsToCents(value: string | number | null | undefined): number {
  if (value == null || value === "") return 0;
  const n = typeof value === "number" ? value : Number(String(value).replace(/[,$\s]/g, ""));
  if (!Number.isFinite(n)) return 0;
  return Math.round(n * 100);
}

/** Cents → `"$1,234.56"` for display. */
export function formatMoney(cents: number | null | undefined): string {
  const dollars = (cents ?? 0) / 100;
  return dollars.toLocaleString("en-US", { style: "currency", currency: "USD" });
}
